import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-bz-slate" data-testid="admin-loading">
        Chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
